module.exports = __webpack_public_path__ + "img/invest_card.bcfe0605.svg";